import React from 'react';

interface IFooterProps {
  children: React.ReactNode;
}

export const Footer: React.FC<IFooterProps> = ({ children }: IFooterProps) => {
  return <footer className="footer">{children}</footer>;
};
